export function serializeDate(date: any): any {
    if (date instanceof Date) {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}T12:00:00`;
    }
    return date;
}

/**
 * Parses a stored date value into a local-time Date anchored at the calendar
 * day, ignoring any time/timezone component. This avoids the off-by-one shift
 * that happens when a date-only string (e.g. "2000-01-01") is fed to
 * `new Date(...)`, which interprets it as UTC midnight and renders the previous
 * day in negative-offset timezones.
 */
export function parseFormDate(value: any): any {
    if (value == null || value instanceof Date) {
        return value;
    }
    if (typeof value === 'string') {
        const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
        if (match) {
            const [, year, month, day] = match;
            return new Date(Number(year), Number(month) - 1, Number(day));
        }
    }
    return value;
}
